export default __webpack_public_path__ + "assets/download.e44f6691.svg";